<div class="container">
  <div class="container__background"></div>
  <div class="container__content">
    <div class="content">
      <div class="content__text">
        <div class="text">
          <p class="text__item">子供は誰だって</p>
          <p class="text__item">この世界の主人公</p>
        </div>
      </div>
      <div class="content__button">
        <app-button
          color="accent-alt"
          size="sm"
          (buttonClick)="onButtonClick()"
        ><b>絵本棚を見る</b></app-button>
      </div>
    </div>
  </div>
</div>
